import { render, staticRenderFns } from "./OptionColumn.vue?vue&type=template&id=1c8df764&scoped=true&"
import script from "./OptionColumn.vue?vue&type=script&lang=js&"
export * from "./OptionColumn.vue?vue&type=script&lang=js&"
import style0 from "./OptionColumn.vue?vue&type=style&index=0&id=1c8df764&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8df764",
  null
  
)

export default component.exports